export default __webpack_public_path__ + "static/media/img-slider-siamblockchain-3.34872a4a.png";